import { cn } from "@/lib/utils";

const BADGE_CLASSES: Record<string, string> = {
  // Overall stages
  active: "bg-green-100 text-green-700",
  onboarding: "bg-yellow-100 text-yellow-700",
  suspended: "bg-red-100 text-red-700",
  churned: "bg-muted text-muted-foreground",

  // Onboarding stages
  registered: "bg-muted text-muted-foreground",
  details_required: "bg-blue-100 text-blue-700",
  verifying: "bg-blue-100 text-blue-700",
  input_required: "bg-yellow-100 text-yellow-700",
  setup_needed: "bg-blue-100 text-blue-700",
  ready: "bg-green-100 text-green-700",

  // Payouts track stages
  idv_input_required: "bg-yellow-100 text-yellow-700",

  // Account health track stages
  ok: "bg-green-100 text-green-700",
  payouts_paused: "bg-red-100 text-red-700",
  charges_blocked: "bg-red-100 text-red-700",

  // Identity / shared track stages
  verified: "bg-green-100 text-green-700",
  pending: "bg-blue-100 text-blue-700",
  issues: "bg-yellow-100 text-yellow-700",
  not_started: "bg-muted text-muted-foreground",

  // Subscription statuses
  trialing: "bg-blue-100 text-blue-700",
  past_due: "bg-red-100 text-red-700",
  inactive: "bg-muted text-muted-foreground",
  incomplete: "bg-yellow-100 text-yellow-700",

  // Onboarding statuses
  completed: "bg-green-100 text-green-700",
  in_progress: "bg-blue-100 text-blue-700",

  // Referral stages
  qualifying: "bg-blue-100 text-blue-700",
  eligible: "bg-yellow-100 text-yellow-700",
  rewarded: "bg-green-100 text-green-700",

  // Activation bonus stages
  empty: "bg-muted text-muted-foreground",
  paid: "bg-green-100 text-green-700",
  expired: "bg-muted text-muted-foreground",
  failed: "bg-red-100 text-red-700",
};

export function StageBadge({
  stage,
  hasError,
  className,
}: {
  stage: string;
  hasError?: boolean;
  className?: string;
}) {
  const classes = hasError
    ? "bg-red-100 text-red-700"
    : // eslint-disable-next-line security/detect-object-injection -- controlled stage values from enums
      (BADGE_CLASSES[stage] ?? "bg-muted text-muted-foreground");
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold",
        classes,
        className,
      )}
    >
      {stage.replace(/_/g, " ")}
      {hasError ? " (error)" : ""}
    </span>
  );
}
